import { useEffect, useState } from "react";
import useAuth from "./useAuth";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { PATH_APP } from "src/routes/paths";

const useInactivity = (timeout = 15) => {
  // 300000 ms = 5 minutos
  const { user } = useAuth();
  const { pathname } = useLocation();

  const [isInactive, setIsInactive] = useState(false);

  useEffect(() => {
    let timer;

    // null/undefined/0/NaN = bloqueo desactivado: no hay temporizador.
    // (Antes `useInactivity(0)` disparaba al instante en el TPV y
    // `useInactivity(NaN)` caía en los 120 s de abajo.)
    if (timeout === null || timeout === undefined) return;
    if (!Number.isFinite(Number(timeout)) || Number(timeout) <= 0) return;

    if (!user) return;

    if (!user.requestUserIdentity) return;

    if (
      pathname !== PATH_APP.tuCarta.tpv &&
      pathname !== PATH_APP.tpv.cartaCamarero
    ) {
      timeout = 120;
    }

    const resetTimer = () => {
      clearTimeout(timer);
      setIsInactive(false); // El usuario está activo
      timer = setTimeout(() => setIsInactive(true), timeout * 1000); // Se considera inactivo después del tiempo especificado
    };

    // Eventos a escuchar
    const events = ["mousemove", "keydown", "click", "scroll", "touchstart"];

    // Añadir listeners a los eventos
    events.forEach((event) => window.addEventListener(event, resetTimer));

    // Iniciar el timer
    resetTimer();

    // Cleanup
    return () => {
      clearTimeout(timer);
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [timeout, user, pathname]);

  return isInactive;
};

export default useInactivity;
